import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  nextItem: false,
  snapshotStarted: false,
  snapshotSuccess: false,
  snapshotFailed: false,
  snapshotCount: 0,
};

export const toastsSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    toggleNextItemToast: (state) => {
      state.nextItem = !state.nextItem;
    },
    showSnapshotToast: (state) => {
      state.snapshotStarted = true;
    },
    hideSnapshotToast: (state) => {
      state.snapshotStarted = false;
    },
    showSnapshotSuccessToast: (state) => {
      state.snapshotSuccess = true;
    },
    hideSnapshotSuccessToast: (state) => {
      state.snapshotSuccess = false;
    },
    showSnapshotFailedToast: (state) => {
      state.snapshotFailed = true;
    },
    hideSnapshotFailedToast: (state) => {
      state.snapshotFailed = false;
    },
    setSnapshotCount: (state, action) => {
      state.snapshotCount = action.payload;
    },
  },
});

export const {
  toggleNextItemToast,
  showSnapshotToast,
  hideSnapshotToast,
  showSnapshotSuccessToast,
  hideSnapshotSuccessToast,
  showSnapshotFailedToast,
  hideSnapshotFailedToast,
  setSnapshotCount,
} = toastsSlice.actions;

export default toastsSlice.reducer;
